import type { Catalog } from "../../en";

/** Filipino: platform admin staff screen (mirrors en). */
export const staff: Catalog["adminScreens"]["staff"] = {
  notAvailable: "Hindi pa available",
  rowActions: "Mga aksyon para kay {{name}}",
  remind: "Paalalahanan",
  clearSearch: "I-clear ang paghahanap",
  menu: {
    reset2fa: "I-reset ang 2FA",
    signOut: "I-sign out sa lahat ng device",
    remove: "Tanggalin ang access",
  },
  invite: {
    meta: "Inimbitahan {{date}} · mag-e-expire sa {{count}} araw",
    meta_other: "Inimbitahan {{date}} · mag-e-expire sa {{count}} araw",
    pending: "Nakabinbing imbitasyon",
    resend: "Ipadala muli",
    revoke: "Bawiin",
  },
  matrix: {
    subtitle: "I-click ang cell para palitan. Laging may lahat ng pahintulot ang Super Admin. Naka-log ang mga pagbabago bilang",
    cellLabel: "{{permission}} para sa {{role}}: {{level}}",
    superAdminLocked: "Laging may lahat ng pahintulot ang Super Admin",
    unsaved: "{{count}} hindi pa naka-save na pagbabago",
    unsaved_other: "{{count}} hindi pa naka-save na pagbabago",
    resetDone: "Ibinalik ang mga pahintulot sa naka-save na matrix",
    save: "I-save",
  },
};
